import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';
import { localeToLanguage } from '~/helpers/format';

export default function useStripe() {
  const { locale } = useLocalization();
  const key = useRuntimeConfig().public.stripePublishableKey;
  const stripe = ref<Stripe | null>(null);

  onMounted(setStripe);

  return {
    stripe
  };

  async function setStripe() {
    stripe.value = await loadStripe(key, {
      locale: localeToLanguage(locale.value)
    });
  }
}